import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { customer_login, messageClear } from '../store/reducers/authReducer';
import toast from 'react-hot-toast';
import { FadeLoader } from 'react-spinners';

const Login = () => {
    const navigate = useNavigate();
    const { loader, errorMessage, successMessage, userInfo, needsVerification } = useSelector(state => state.auth);
    const dispatch = useDispatch();

    const [state, setState] = useState({
        email: '',
        password: ''
    });

    const inputHandle = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    };

    const login = (e) => {
        e.preventDefault();
        dispatch(customer_login(state));
    };

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
        if (needsVerification) {
            navigate('/verify-email');
        } else if (userInfo) {
            navigate('/');
        }
    }, [successMessage, errorMessage, userInfo, needsVerification, dispatch, navigate]);

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
            {loader && (
                <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-black/30 backdrop-blur-sm z-[999]'>
                    <FadeLoader color='#06b6d4' />
                </div>
            )}
            <Header />

            <div className='py-12 md:py-6'>
                <div className='w-[90%] max-w-md mx-auto'>
                    {/* Login Card */}
                    <div className='bg-white rounded-2xl shadow-xl p-8 border border-gray-100'>
                        {/* Header */}
                        <div className='text-center mb-8'>
                            <h2 className='text-2xl font-bold text-gray-900 mb-2'>Welcome Back</h2>
                            <p className='text-gray-500'>Sign in to your account</p>
                        </div>

                        {/* Form */}
                        <form onSubmit={login} className='space-y-5'>
                            <div>
                                <label htmlFor="email" className='block text-sm font-medium text-gray-700 mb-2'>
                                    Email Address
                                </label>
                                <input
                                    onChange={inputHandle}
                                    value={state.email}
                                    className='w-full px-4 py-3 outline-none border border-gray-200 rounded-xl text-gray-700 placeholder-gray-400 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-all text-base'
                                    type="email"
                                    name="email"
                                    id="email"
                                    inputMode="email"
                                    autoComplete="email"
                                    autoCapitalize="none"
                                    autoCorrect="off"
                                    spellCheck={false}
                                    enterKeyHint="next"
                                    placeholder='Enter your email'
                                    required
                                />
                            </div>

                            <div>
                                <label htmlFor="password" className='block text-sm font-medium text-gray-700 mb-2'>
                                    Password
                                </label>
                                <input
                                    onChange={inputHandle}
                                    value={state.password}
                                    className='w-full px-4 py-3 outline-none border border-gray-200 rounded-xl text-gray-700 placeholder-gray-400 focus:border-cyan-500 focus:ring-2 focus:ring-cyan-500/20 transition-all text-base'
                                    type="password"
                                    name="password"
                                    id="password"
                                    autoComplete="current-password"
                                    enterKeyHint="go"
                                    placeholder='Enter your password'
                                    required
                                />
                            </div>

                            <div className='flex justify-end -mt-2'>
                                <Link to='/forgot-password' className='text-sm text-cyan-600 hover:text-cyan-700 font-medium'>
                                    Forgot password?
                                </Link>
                            </div>

                            <button className='w-full py-3.5 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white font-semibold rounded-xl shadow-lg shadow-cyan-500/30 hover:shadow-xl hover:shadow-cyan-500/40 transition-all'>
                                Sign In
                            </button>
                        </form>

                        {/* Register Link */}
                        <div className='mt-6 text-center'>
                            <p className='text-gray-600'>
                                Don't have an account?{' '}
                                <Link to='/register' className='text-cyan-600 font-semibold hover:text-cyan-700 transition-colors'>
                                    Register
                                </Link>
                            </p>
                        </div>

                        {/* Divider */}
                        <div className='flex items-center my-6'>
                            <div className='flex-1 h-px bg-gray-200'></div>
                            <span className='px-4 text-sm text-gray-400'>Are you a seller?</span>
                            <div className='flex-1 h-px bg-gray-200'></div>
                        </div>

                        {/* Seller Links */}
                        <div className='space-y-3'>
                            <a
                                target='_blank'
                                rel="noreferrer"
                                href="https://nimbo-dashboard.vercel.app/login"
                                className='block w-full py-3 text-center bg-gray-100 text-gray-700 font-medium rounded-xl hover:bg-gray-200 transition-colors'
                            >
                                Login as Seller
                            </a>
                            <a
                                target='_blank'
                                rel="noreferrer"
                                href="https://nimbo-dashboard.vercel.app/register"
                                className='block w-full py-3 text-center border border-gray-200 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors'
                            >
                                Register as Seller
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Login;
